import React, { useState } from 'react';
import './accordionDrawer.scss';

interface AccordionProps {
  title: string;
  tagline?: string;
  children: React.ReactNode;
  isExpanded?: boolean;
  arrowIcon?: React.ReactNode;
  onToggle?: (isExpanded: boolean) => void;
}

const Accordion: React.FC<AccordionProps> = ({
  title,
  tagline = '',
  children,
  isExpanded: controlledExpanded,
  arrowIcon = <span className="triangle-icon"></span>,
  onToggle,
}) => {
  const [internalExpanded, setInternalExpanded] = useState(false);
  // Use controlled state if provided, otherwise use internal state
  const isExpanded = controlledExpanded !== undefined ? controlledExpanded : internalExpanded;

  const toggleAccordion = () => {
    const newState = !isExpanded;
    if (onToggle) {
      onToggle(newState);
    } else {
      setInternalExpanded(newState);
    }
  };

  return (
    <div className={`pck-accordion ${isExpanded ? 'expanded' : ''}`}>
      <div className="pck-accordion-button" onClick={toggleAccordion}>
        <span className="diy-drawer-section-label">
          {title}
          {tagline && (
            <>
              <br />
              <small className="pck-accordion-tagline">{tagline}</small>
            </>
          )}
        </span>
        <span className={`pck-accordion-icon ${isExpanded ? 'down' : 'up'}`}>{arrowIcon}</span>
      </div>
      <div className="pck-accordion-content">{isExpanded ? children : null}</div>
    </div>
  );
};

export default Accordion;
